import {
  forwardCurveExpandedAtom,
  forwardCurveVisibleAtom,
  forwardCurveWindowAtom,
  type ForwardCurveCurve,
} from "../forward-curve-chart/state";
import type { Action } from "./types";

/**
 * Opens the floating Forward Curve window for the currently selected curves.
 * Supports both single- and multi-Curve selection.
 */
export const viewForwardCurve: Action = (ctx) => {
  if (ctx.disabledFeatures?.hfc) return;

  const cells = ctx.rangeSelection ?? [];

  // Unique columnIds, preserving the order they appeared in the selection
  const seen = new Set<string>();
  const columnIds: string[] = [];
  for (const cell of cells) {
    if (!cell?.columnId || seen.has(cell.columnId)) continue;
    seen.add(cell.columnId);
    columnIds.push(cell.columnId);
  }
  if (columnIds.length === 0 && ctx.columnId) {
    columnIds.push(ctx.columnId);
  }
  if (columnIds.length === 0) return;

  const curves: ForwardCurveCurve[] = columnIds
    .map((columnId) => {
      const column = ctx.api.getColumn(columnId);
      if (!column) return null;
      const colDef = column.getColDef();
      const headerParams = colDef.headerComponentParams;
      if (!headerParams?.productId) return null;
      const displayName = colDef.headerName || column.getColId();
      return { columnId, displayName } satisfies ForwardCurveCurve;
    })
    .filter(Boolean) as ForwardCurveCurve[];

  if (curves.length === 0) return;

  const visible: Record<string, boolean> = {};
  for (const c of curves) visible[c.columnId] = true;

  ctx.store.set(forwardCurveVisibleAtom, visible);
  ctx.store.set(forwardCurveExpandedAtom, false);
  ctx.store.set(forwardCurveWindowAtom, { open: true, curves });
};
